import { Activity } from "@ofqual/portal-activity-feed";
import { DownloadLink } from "@ofqual/portal-components/components/DownloadLink";
import { useSelector } from "react-redux";
import { LcmAttachment } from "../../domain/LcmAttachment";
import { LcmModel } from "../../domain/LcmModel";
import { authSelector } from "../../redux/selectors";
import { lcmService } from "../../services";
import { SupportedDocumentType } from "./SupportedDocumentType";
import VisibilityIcon from '@material-ui/icons/Visibility';
import Button from "@material-ui/core/Button";

export const PreviewDocument: React.FC<{ doc: LcmAttachment, lcmItem: LcmModel, activity: Activity }> = ({ doc, lcmItem, activity }) => {
  const { token } = useSelector(authSelector);
  const buildGetBlob = (blobId: string, isBlob: boolean) => () =>
    lcmService.downloadAttachment(lcmItem.id, activity.id, blobId, isBlob,
      {
        token,
      });

  const handleFileOpen = (url: string) => {
    window.open(url, '_blank');
  }

  const handleFileClick = async () => {
    buildGetBlob(doc.blobId, false)()
      .then((res: any) => {
        handleFileOpen(res.location);
      })
      .catch(e => console.log(e));
  }

  switch (doc.contentType) {
    case SupportedDocumentType.Word:
    case SupportedDocumentType.Excel:
    case SupportedDocumentType.OpenWord:
    case SupportedDocumentType.OpenExcel:
    case SupportedDocumentType.Csv:
    case SupportedDocumentType.Ppt:
    case SupportedDocumentType.Pdf:
    case SupportedDocumentType.Jpg:
    case SupportedDocumentType.Jpeg:
    case SupportedDocumentType.Png:
      return <Button style={{ textTransform: "none", fontWeight: 600, fontSize: "0.75rem" }} variant="contained" color="primary" onClick={handleFileClick} endIcon={<VisibilityIcon />}>
        {doc.fileName}
      </Button>
    default:
      return <DownloadLink
        fileName={doc.fileName}
        getBlob={buildGetBlob(doc.blobId, true) as unknown as () => Promise<Blob>}
      />
  }
}